import { array, object, optional } from 'superstruct';
import { EditPermissionsDto } from '@arc/shared/util-data';
import { ViewRoleDto } from '@arc/shared/util-roles';
import { email, parsableBoolean, phoneNumber, userString } from '@arc/shared/util-superstruct';
export const AddUserFormDto = object({
  name: userString('validations:Required'),
  email: email(),
  phone: optional(phoneNumber()),
  superuser: optional(parsableBoolean()),
  permissions: EditPermissionsDto,
  roles: optional(array(ViewRoleDto)),
  sendWelcomeEmail: parsableBoolean()
});